import React from 'react';
import styles from './Project.module.scss';

function Project({ href, image, desc }) {
  return (
    <a href={href}>
      <div className={styles.grid_item}>
        <img className={styles.image} src={image} alt="mockup of website" />
        <div className={styles.desc}>
          <p>{desc}</p>
        </div>
      </div>
    </a>
  );
}

export default Project;
